<template>
  <div class="login">
    <p>授权加载中，请稍候...</p>
  </div>
</template>

<script>
  let beforeQuery = {}
  export default {
    data() {
      return {
        code: undefined
      }
    },
    mounted() {
      this.getCode()
      // this.getCodeProd()
    },
    methods: {
      /**
       * todo url获取code，跳转到微信地址返回code
       */
      getCodeProd() {
        beforeQuery = { ...JSON.parse(window.sessionStorage.getItem('query')) }
        const AppId = process.env.VUE_APP_APPID
        const { code: Code } = this.$route.query
        const local = encodeURIComponent(window.location.href)
        if (!Code) {
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${AppId}&redirect_uri=${local}&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect`
        } else {
          this.getOpenId(Code)
        }
      },
      /**
       * todo url获取code，跳转到微信地址返回code
       */
      getCode() {
        beforeQuery = { ...JSON.parse(window.sessionStorage.getItem('query')) }
        const AppId = process.env.VUE_APP_APPID
        const { code: Code } = this.$route.query
        const local = window.location.href
        /**
         * todo 本地开发环境
         * @description 跳过微信验证权限
         */
        if (process.env.NODE_ENV === 'development') {
          this.getOpenId()
        } else {
          if (!Code) {
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${AppId}&redirect_uri=${local}&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect`
          } else {
            this.getOpenId(Code)
          }
        }
      },
      /**
       * todo 获取微信用户信息，通过code获取, 或者通过openId获取
       * @param {code: code码}
       */
      getOpenId(code) {
        /**
         * todo 本地测试模拟用户账号
         * @description 本地开发环境生效
         */
        // let result
        // if (process.env.NODE_ENV === 'development') {
        //   result = {
        //     userid: 216406,
        //     sex: 0,
        //     openid: 'owHN-uFdwBtnMif814_rMBbpcxu8',
        //     nickname: '弓矢之开弓',
        //     logintime: 'Oct 8, 2024 1:41:42 PM',
        //     lastlogintime: 'Oct 8, 2024 1:41:42 PM',
        //     accessToken: '85_CaonQOp6nLF5A9CW90bTdwNoGx0XgiPBw12BnrDQgiD0AkrtxTiOJJhTrFm8QB8336QcND6HWtZMJxO6-RAWVa2Z47EvohVpBTEa78rjOZk',
        //     refreshToken: '85_Hskz7JFhRobYv_DfkEZ_yAD6NdosO48BZhh2N0yE7Imlv1HvWzjrS2SZc-xy5i1WBaOHdarY-6NYpzZn7FuKv2wrJka-SU7_95Ob70QqOeo',
        //     expiresIn: 7200
        //   }
        //   window.sessionStorage.setItem('userInfo', JSON.stringify(result))
        // }
        const { redirect_url } = this.$route.query
        let query = { ...beforeQuery }
        query.code = undefined
        query.redirect_url = undefined
        let info = JSON.parse(window.sessionStorage.getItem('userInfo'))
        let openId = info && info.openid
        let params = {
          code: openId ? undefined : code,
          openID: openId || undefined
        }

        // this.$router.push({ name: redirect_url ? redirect_url : 'Entry', query })

        this.$api.user.getLoginUser(params).then((res) => {
          let { result } = res
          if (result && JSON.stringify(result) !== '{}') {
            try {
              let { openid } = result
              this.$store.dispatch('user/updateActionOpenId', openid)
              this.$store.dispatch('user/updateActionUserInfo', result)
              window.sessionStorage.setItem('userInfo', JSON.stringify(result))
              this.$router.push({ name: redirect_url ? redirect_url : 'Entry', query })
            } catch (error) {
              alert(JSON.stringify(error))
            }
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login {
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      text-align: center;
    }
  }
</style>
